import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Box, Button, Menu, MenuItem, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useToken } from "../../account";
import { dxtToLocalServerTime } from "../../services";

export const TimeAndUserMenu = () => {
	const { getUserName } = useToken();
	const [userName, setUserName] = useState(getUserName());
	const [date, setDate] = useState(new Date());
	const [userMenuAnchorEl, setUserMenuAnchorEl] = useState<null | HTMLElement>(
		null,
	);

	const tick = () => {
		setDate(new Date());
		// Also update username in case it changed
		const currentName = getUserName();
		if (currentName !== userName) {
			setUserName(currentName);
		}
	};

	useEffect(() => {
		const timerID = setTimeout(() => {
			tick();
		}, 1000);
		return () => {
			clearTimeout(timerID);
		};
	});

	const handleUserMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
		setUserMenuAnchorEl(event.currentTarget);
	};

	const handleUserMenuClose = () => {
		setUserMenuAnchorEl(null);
	};

	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				color: "white",
			}}
		>
			<Typography
				variant="body2"
				sx={{
					marginRight: 2,
					color: "white",
				}}
			>
				{dxtToLocalServerTime(date, "HH:mm:ss z")}
			</Typography>

			<Button
				onClick={handleUserMenuOpen}
				color="inherit"
				sx={{
					marginLeft: 1,
					display: "flex",
					alignItems: "center",
					color: "white",
				}}
			>
				<AccountCircleIcon
					sx={{
						marginRight: 1,
						color: "white",
					}}
				/>
				{userName}
			</Button>

			<Menu
				id="user-menu"
				anchorEl={userMenuAnchorEl}
				keepMounted
				open={Boolean(userMenuAnchorEl)}
				onClose={handleUserMenuClose}
			>
				<MenuItem component="a" href="account">
					Account
				</MenuItem>
				<MenuItem component="a" href="logout">
					Logout
				</MenuItem>
			</Menu>
		</Box>
	);
};
